import { defineMessages } from 'react-intl';

const _default_1: {
    goal: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    loomVideo: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    loomVideoIcon: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    object: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    page: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    project: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    team: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    whiteboard: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    workItem: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
    workItem: {
        id: 'navigation.preview-panel-global-objects.workItem',
        defaultMessage: 'Jira work item',
        description: 'Title for the work item preview panel',
    },
    project: {
        id: 'navigation.preview-panel-global-objects.project',
        defaultMessage: 'Project',
        description: 'Title for the project preview panel',
    },
    goal: {
        id: 'navigation.preview-panel-global-objects.goal',
        defaultMessage: 'Goal',
        description: 'Title for the goal preview panel',
    },
    team: {
        id: 'navigation.preview-panel-global-objects.team',
        defaultMessage: 'Team',
        description: 'Title for the team preview panel',
    },
    page: {
        id: 'navigation.preview-panel-global-objects.page',
        defaultMessage: 'Confluence Page',
        description: 'Title for the Confluence page preview panel',
    },
    whiteboard: {
        id: 'navigation.preview-panel-global-objects.whiteboard',
        defaultMessage: 'Confluence Whiteboard',
        description: 'Title for the Confluence whiteboard preview panel',
    },
    object: {
        id: 'navigation.preview-panel-global-objects.object',
        defaultMessage: 'Assets Object',
        description: 'Title for the object preview panel',
    },
    loomVideo: {
        id: 'navigation.preview-panel-global-objects.loomVideo',
        defaultMessage: 'Loom Video',
        description: 'Title for the Loom video preview panel',
    },
    loomVideoIcon: {
        id: 'navigation.preview-panel-global-objects.loomVideoIcon',
        defaultMessage: 'Loom Video Icon',
        description: 'Icon for the Loom video preview panel',
    },
});
export default _default_1;
